<template>
  <div>
    <h1>Pending verification</h1>
    <table class="clickable mt-10">
      <thead>
        <th>Name</th>
        <th>Owner</th>
        <th>Phone</th>
      </thead>
      <tbody>
        <tr
          v-for="business in pendingVerification.data"
          :key="business.id"
          @click="
            $router.push({
              name: 'pending-detail',
              params: { id: business.id }
            })
          "
        >
          <td>{{ business.name }}</td>
          <td>{{ business.owner.name }}</td>
          <td>{{ business.phone }}</td>
        </tr>
      </tbody>
    </table>

    <el-pagination
      class="mt-10"
      :current-page="pendingVerification.pagination.currentPage"
      layout="pager"
      :total="pendingVerification.pagination.totalCount"
      @current-change="pageChanged"
      :page-size="30"
      hide-on-single-page
    />
  </div>
</template>

<script>
import { PENDING_BUSINESS_VERIFICATION_QUERY } from "@/api/queries";

export default {
  apollo: {
    pendingVerification: {
      query: PENDING_BUSINESS_VERIFICATION_QUERY,
      variables: {
        page: 1,
        per: 30
      }
    }
  },
  data() {
    return {
      pendingVerification: {
        data: [],
        pagination: { currentPage: 1, totalCount: 0 }
      },
      page: 1
    };
  },
  methods: {
    pageChanged(page) {
      this.$apollo.queries.pendingVerification.refetch({ page });
    }
  }
};
</script>
